/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { MissingReceiptsDto, TransactionFilterRequest } from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class MissingInformationController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags missing-information-controller
   * @name NotifyAboutMissingInformation
   * @request POST:/api/v1/missing-information/notify
   */
  notifyAboutMissingInformation = (data: TransactionFilterRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/missing-information/notify`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static notifyAboutMissingInformationPath = '/v1/missing-information/notify'
  static notifyAboutMissingInformationMethod = 'POST'
  /**
   * No description
   *
   * @tags missing-information-controller
   * @name GetMissingInformationGroupedByUser
   * @request POST:/api/v1/missing-information/grouped-by-user
   */
  getMissingInformationGroupedByUser = (
    data: TransactionFilterRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<MissingReceiptsDto[], any>({
      path: `/v1/missing-information/grouped-by-user`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static getMissingInformationGroupedByUserPath = '/v1/missing-information/grouped-by-user'
  static getMissingInformationGroupedByUserMethod = 'POST'
}
